import {
    Home,
    Box,
    DollarSign,
    Tag,
    Clipboard,
    Camera,
    AlignLeft,
    UserPlus,
    Users,
    Chrome,
    BarChart,
    Settings,
    Archive,
    LogIn,
    DownloadCloud,
    ShoppingCart,
    CreditCard,
} from 'react-feather';

export const MENUITEMS = [
    {
        path: '/dashboard',
        title: 'Dashboard',
        icon: Home, // Home icon for Dashboard
        type: 'link',
        badgeType: 'primary',
        active: false,
    },
    {
        title: 'Brand List',
        path: '/brand-list',
        icon: Tag, // Tag icon for Brand List
        type: 'link',
        active: false,
    },
    {
        title: 'Voucher List',
        path: '/voucher-list',
        icon: DownloadCloud, // DownloadCloud icon for Voucher List
        type: 'link',
        active: false,
    },
    {
        title: 'Purchase List',
        path: '/purchase-list',
        icon: ShoppingCart, // ShoppingCart icon for Purchase List
        type: 'link',
        active: false,
    },
    {
        title: 'Transaction List',
        path: '/transaction-list',
        icon: CreditCard, // CreditCard icon for Transaction List
        type: 'link',
        active: false,
    },
    {
        title: 'Negotiate List',
        path: '/negotiate-list',
        icon: DollarSign, // CreditCard icon for Transaction List
        type: 'link',
        active: false,
    },
    {
        title: 'User List',
        path: '/user-list',
        icon: Users, // Users icon for User List
        type: 'link',
        active: false,
    },
];
